<template>
  <div class="initialization-page">
    <div class="content">
      <infinity-spinner />
    </div>
  </div>
</template>
<script lang="ts" setup>
import InfinitySpinner from './InfinitySpinner.vue';

</script>
<style lang="scss">
.initialization-page {
  width: 100%;
  display: flex;
  background-color: var(--pidz-blue);
  padding: 48px 16px 16px 16px;
  align-items: center;
  position: absolute;
  height: 100%;

  .content {
    display: flex;
    flex-grow: 1;
    flex-direction: row;
    justify-content: space-around;

  }
}
</style>
